import { Component, OnInit,Input, Output,EventEmitter, OnChanges, AfterViewInit, SimpleChange  } from '@angular/core';
import { NormasService } from 'app/_services/normas.service';
import { EmpresasService } from 'app/_services/empresas.service';


@Component({
  selector: 'normafiltros',
  templateUrl: './normafiltros.component.html',
  styleUrls: ['./normafiltros.component.css']
})
export class NormafiltrosComponent implements OnInit,AfterViewInit, OnChanges {

  @Input() _listaNormas: any; 

  @Output() onChangeValue = new EventEmitter<any>();

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';
  spinner:boolean = false;

  listanormas: any=[];
  listaNormasFiltro: any=[];
  listanormasfiltro: any = [];
 
  listaetiquetas: any = [];
  listaetiquetasfiltro: any = [];
  filtroetiquetas: string = "xxxxxxx"; //forzamos así que no encuentre resultados en el listado
  nuevaetiqueta: string = "";
  finalizado: boolean = false;
  revisado: boolean = false;
  listaAmbitos: any = [];

  listamarcos: any = [];
  listapaises: any = [];
  listacomunidades: any = [];
  listaprovincias: any = [];
  listamunicipios: any = [];
  filtro_id_ambito: number = 0;
  filtro_id_ambito_internacional: number = 0;
  filtro_id_ambito_nacional: number = 0;
  filtro_id_ambito_autonomico: number = 0;
  filtro_id_ambito_provincial: number = 0;
  filtro_id_ambito_local: number = 0;

  constructor(private normasService: NormasService,
              private empresasService: EmpresasService) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_listaNormas']){
      this.listaNormasFiltro = changes['_listaNormas'].currentValue;
      this.listanormas = changes['_listaNormas'].currentValue;
    }
    console.log(this.listaNormasFiltro);
    this.getListaEtiquetas();
    this.getListaAmbitos();
    this.getListaMarcos();
    this.getListaPaises();
    this.getListaComunidades();
  }



  ngOnInit() {
    
  }

  ngAfterViewInit(){
   
  }

  getListaEtiquetas(){
    this.normasService.getListaEtiquetasNorma().subscribe(
      data => {
        if (data){
          this.listaetiquetas = data.json().lista;
        }
      }
    );
  }

  filtroEtiquetas(){
    if (this.nuevaetiqueta.length > 1){
      this.filtroetiquetas = this.nuevaetiqueta;
    }else{
      this.filtroetiquetas = "xxxxxxx";
    }
  }

  anadirEtiqueta(){
    this.listaetiquetasfiltro.push(this.nuevaetiqueta);
    this.nuevaetiqueta = "";
    this.filtroEtiquetas();
    this.aplicarFiltros();
  }

  eliminarEtiqueta(index: number){
    this.listaetiquetasfiltro.splice(index,1);
    this.aplicarFiltros();
  }

 onSaveFinalizado(value:boolean){
    this.finalizado = value;
    this.aplicarFiltros();
  }

  onSaveRevisado(value:boolean){
    this.revisado = value;
    this.aplicarFiltros();
  }


  resetAmbitos(){

    this.filtro_id_ambito_nacional = 0;
    this.filtro_id_ambito_internacional = 0;
    this.filtro_id_ambito_autonomico = 0;
    this.filtro_id_ambito_provincial = 0;
    this.filtro_id_ambito_local = 0;
  }

  getListaAmbitos(){
    this.normasService.getListaAmbitos().subscribe(
      data => {
        if (data){
          this.listaAmbitos = data.json().lista;
        }
      }
    );
  }

  getListaMarcos(){

    let params = {
      action: "ListagetMarcos"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamarcos = data.json().lista;
          }
        }
    );

  }

  getListaPaises(){

    let params = {
      action: "ListagetPaises"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listapaises = data.json().lista;
          }
        }
    );

  }

  getListaComunidades(){

    let params = {
      action: "ListagetComunidades"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacomunidades = data.json().lista;
          }
        }
    );

  }

  getListaProvincias(id_comunidad: any){

    let params = {
      action: "ListagetProvincias",
      id_comunidad: id_comunidad
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
            this.filtro_id_ambito_local = 0;
            this.aplicarFiltros();
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
            this.aplicarFiltros();
          }
        }
    );

  }

  aplicarFiltros(){

    let auxnormas = this.listanormas;

    this.listanormasfiltro = [];

    //recorremos los filtros de las etiquetas para restringir el array de normas
    if (this.listaetiquetasfiltro.length > 0){
      for (let norma of this.listanormas){

        let aux = 1;

        for (let eti of this.listaetiquetasfiltro){

          if (norma.etiquetas.length > 0){

            let encontrado = 0;

            for (let etiqueta of norma.etiquetas){
              if (etiqueta.descripcion == eti){
                encontrado = 1;
              }
            }

            if (encontrado == 0){
              aux = 0;
            }

          }else{
            aux = 0;
          }

        }

        if (aux == 1){
          this.listanormasfiltro.push(norma);
        }

      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;
    //********************* fin filtro etiquetas **************************

    /*********************** filtro revisado y finalizado ******************/

    if(this.finalizado){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.finalizado == 1){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }
    auxnormas = this.listanormasfiltro;

    if(this.revisado){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.revisado == 1){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }
    auxnormas = this.listanormasfiltro;
    /*********************** filtro revisado y finalizado ******************/

    /*********************** filtro ambitos ********************************/

    if (this.filtro_id_ambito != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito == this.filtro_id_ambito){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_internacional != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_internacional == this.filtro_id_ambito_internacional){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_nacional != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_nacional == this.filtro_id_ambito_nacional){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;

    if (this.filtro_id_ambito_autonomico != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_autonomico == this.filtro_id_ambito_autonomico){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;


    if (this.filtro_id_ambito_provincial != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_provincial == this.filtro_id_ambito_provincial){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;


    if (this.filtro_id_ambito_local != 0){
      this.listanormasfiltro = [];
      for (let norma of auxnormas){
        if (norma.id_ambito_local == this.filtro_id_ambito_local){
          this.listanormasfiltro.push(norma);
        }
      }
    }else{
      this.listanormasfiltro = auxnormas;
    }

    auxnormas = this.listanormasfiltro;
    /*********************** filtro ambitos ********************************/


    this.listanormasfiltro = auxnormas;

    console.log(this.listanormasfiltro);

    this.listaNormasFiltro = this.listanormasfiltro;

    this.onChangeValue.emit({value:this.listaNormasFiltro ,tipo:"filtrar"});

  }


  limpiarFiltros(){
    this.revisado = false;
    this.finalizado = false;
    this.listaetiquetasfiltro = [];
    this.filtro_id_ambito = 0 ;
    this.resetAmbitos();
    this.onChangeValue.emit({value:-1,tipo:"limpiar"});
   
  }

}



// WEBPACK FOOTER //
// ./src/app/normafiltros/normafiltros.component.ts